import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import Header from "go-app/components/Header";
import SubmenuAdvancedNavigation from "./components/SubmenuAdvancedNavigation";
import OrganizationSettingsAdvancedCopyPlacePage from "./pages/CopyPlace";
import OrganizationSettingsAdvancedOthersPage from "./pages/Others";
import OrganizationSettingsAdvancedToolsPage from "./pages/Tools";

const OrganizationSettingsAdvancedPage: FC<RouteComponentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<div className="content">
			<Header title={t("modules.setting.field.data_export_import.title")} />
			<SubmenuAdvancedNavigation />
			<Switch>
				<Route path={`${props.match.url}/copy-place`} component={OrganizationSettingsAdvancedCopyPlacePage} />
				<Route path={`${props.match.url}/tools`} component={OrganizationSettingsAdvancedToolsPage} />
				<Route path={`${props.match.url}/others`} component={OrganizationSettingsAdvancedOthersPage} />
				{/*<Route path={props.match.url + "/copy-test-place"}*/}
				{/*       component={OrganizationSettingsAdvancedCopyTestPlacePage}/>*/}
				<Redirect from={props.match.url} to={`${props.match.url}/copy-place`} />
			</Switch>
		</div>
	);
};

export default OrganizationSettingsAdvancedPage;
